const DasWBGTSvgColor = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.83398"
      y="16.5"
      width="4.16667"
      height="10.8333"
      fill="#FF6B00"
    />
    <rect x="6.83398" y="13.1667" width="18.3333" height="2.5" fill="#A1A1A1" />
    <rect x="6" y="11.5" width="20" height="1.66667" fill="#A1A1A1" />
    <rect x="21" y="16.5" width="4.16667" height="10.8333" fill="#FF6B00" />
    <rect x="11.834" y="16.5" width="8.33333" height="10.8333" fill="#656565" />
    <ellipse cx="9.33398" cy="6.5" rx="2.5" ry="2.5" fill="#A1A1A1" />
    <path
      d="M17.25 8.16666L14.75 8.16666L13.5 5.66666L18.5 5.66666L17.25 8.16666Z"
      fill="#A1A1A1"
    />
    <path
      d="M15.5827 7.33333H16.416L16.8327 10.6667H15.166L15.5827 7.33333Z"
      fill="#A1A1A1"
    />
    <path
      d="M8.91667 7.33333H9.75L10.1667 10.6667H8.5L8.91667 7.33333Z"
      fill="#A1A1A1"
    />
    <path
      d="M22.2507 7.33333H23.084L23.5007 10.6667H21.834L22.2507 7.33333Z"
      fill="#A1A1A1"
    />
    <path d="M21.8333 4H23.5L24.3333 8.16667H21L21.8333 4Z" fill="#A1A1A1" />
  </svg>
);

export default DasWBGTSvgColor;
